import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import { ReactNode } from "react"

interface Props {
    /** "Independent corners", "Independent margins"… — the tooltip and the accessible name */
    title: string
    icon: ReactNode
    active: boolean
    onClick: () => void
    disabled?: boolean
}

/**
 * The toggle that splits a shared field into one field per side or corner (see
 * useLinkedStyles). Grey at rest, white on a round dark background on hover, the brand color
 * while on — the same for every group, so they all read as one control.
 */
const IndependentToggle = ({ title, icon, active, onClick, disabled }: Props) => (
    <Tooltip title={title}>
        {/* span: a disabled button fires no events, so the tooltip needs a wrapper */}
        <span>
            <IconButton
                size="small"
                aria-label={title}
                aria-pressed={active}
                onClick={onClick}
                disabled={disabled}
                sx={{
                    color: active ? "primary.main" : "text.secondary",
                    "&:hover": { color: active ? "primary.main" : "text.primary" },
                }}
            >
                {icon}
            </IconButton>
        </span>
    </Tooltip>
)

export default IndependentToggle
